import React from "react";
import ImageStack from "./common/CardStack";
import OliveSwiper from "./common/OliveSwiper";
import localVideo from "../assets/videos/scanner.mov"

export default function HowItWorks() {
  const chips = [
    "No Preservatives",
    "High Protein",
    "Low Sugar",
    "Organic",
    "Gluten Free",
    "Rich in Fiber",
  ];

  return (
    <section className="section -mt-[200px] relative z-50 w-full">
      <h1 className="heading">
        How the Olive Food <br />
        Scanner App Works 🥑
      </h1>

      <div className="cards">
        {/* CARD 1 */}
        <div className="card">
          <div className="title">Scan & Detect</div>

          <div className="content">
            <video src={localVideo} autoPlay loop muted playsInline />
          </div>

          <p className="desc">
            When you open Olive simply scan the barcode to instantly detect
            product ingredients. Olive helps you identify harmful substances
            quickly and easily.
          </p>
        </div>

        {/* CARD 2 */}
        <div className="card">
          <div className="title">Data Analysis & Validation</div>

          <div className="content col">
            <OliveSwiper/>

            <div className="safe -mt-11">✓ Safe to consume</div>
          </div>

          <p className="desc">
            Olive compares products with a trusted database and validates
            ingredients using expert nutritional standards.
          </p>
        </div>

        {/* CARD 3 */}
        <div className="card">
          <div className="title">Actionable Insights & Recommendations</div>

          <div className="content chips-box">
            <div className="chips-track">
              {[...chips, ...chips].map((text, i) => (
                <div key={i} className="chip">
                  {text}
                </div>
              ))}
            </div>

            <div className="">
              <ImageStack />
            </div>
            {/* <img src="/images/main-product.png" className="center-img" /> */}
          </div>

          <p className="desc">
            Olive provides tailored insights and healthier alternatives so you
            can confidently choose better products every day.
          </p>
        </div>
      </div>
    </section>
  );
}